import React from 'react';
import styled from 'styled-components';
import { Link, withRouter } from 'react-router-dom';
import Navigation from './Navigation';
import bookMeButton from '../assets/button.gif';
import MobileToggle from './MobileToggle';
import MobileNavigation from './MobileNavigation';

// STYLES
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 15px 0 15px;
  background-color: white;
  position: fixed;
  left: 0;
  right: 0;

  @media only screen and (min-width: ${props => props.theme.bp.navigation}) {
    padding-top: 12rem;
    position: static;
  }
`;

const BookMeButton = styled.img`
  
`;

const StyledLink = styled(Link)`
  width: 95px;
  height: 95px;
  margin-left: auto;
`;

const StyledNavigation = styled(Navigation)`
  display: none;

  @media only screen and (min-width: ${props => props.theme.bp.navigation}) {
    display: block;
  }
`;

const StyledMobileToggle = styled(MobileToggle)`
  display: inline-block;

  @media only screen and (min-width: ${props => props.theme.bp.navigation}) {
    display: none;
  }
`;

const StyledMobileNavigation = styled(MobileNavigation)`

`;


// COMPONENT
class Header extends React.Component {

  state = {
    showMobileNav: false
  }

  mobileToggleHandler = () => {
    this.setState(state => ({ showMobileNav: !state.showMobileNav }));
  };

  mobileHideHandler = () => {
    this.setState({ showMobileNav: false });
  };

  render() {
    return (
      <HeaderContainer>
        <StyledNavigation />
        <StyledMobileToggle toggle={ this.mobileToggleHandler } icon={this.state.showMobileNav} />
        <StyledLink to="/kontakt"><BookMeButton src={bookMeButton} alt="Buchen Sie mich!" /></StyledLink>
        <StyledMobileNavigation show={ this.state.showMobileNav } toggle={ this.mobileToggleHandler } />
      </HeaderContainer>
    );
  }
}

export default withRouter(Header);